angular.module('user-data-storage', [])
	.service('Storage', Storage);

Storage.$inject = ['$rootScope', '$q', '$timeout'];

function Storage($rootScope, $q, $timeout) {
	function isLocalStorageAvailable() {
		var test = 'test';
		try {
			localStorage.setItem(test, test);
			localStorage.removeItem(test);
			return true;
		} catch (e) {
			return false;
		}
	}

	var userLocalStorage = {};
	var storage;

	if (isLocalStorageAvailable()) {
		storage = window.localStorage;
	} else {
		storage = {
			key: function(i) {
				return Object.keys(userLocalStorage)[i] || null;
			},
			getItem: function(key) {
				return userLocalStorage[key] || null;
			},
			setItem: function(key, value) {
				userLocalStorage[key] = String(value);
			},
			removeItem: function(key) {
				delete userLocalStorage[key];
			},
			clear: function() {
				userLocalStorage = {};
			}
		};
	}

	return storage;
}



/*****************
 ** WEBPACK FOOTER
 ** ./app/components/user-data-storage/services/user-data-storage.js
 ** module id = 117
 ** module chunks = 1
 **/